export default __webpack_public_path__ + "static/media/cart.2b340a39.svg";